<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="diagramInfo"
               :rules="diagramRules"
               ref="diagramForm"
               label-width="100px"
               class="diagram-form">
        <el-form-item label="房型名称："
                      prop="name">
          <el-input v-model.trim="diagramInfo.name"
                    placeholder="请输入房型名称"></el-input>
        </el-form-item>
        <el-form-item label="房型："
                      prop="picture">
          <el-upload :action="imgUpUrl"
                     :headers="{token: authId}"
                     :on-preview="handlePreview"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="pictureList"
                     list-type="picture">
            <el-button size="small"
                       type="primary">点击上传</el-button>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%"
                 :src="imgDownUrl + diagramInfo.picture"
                 alt="" />
          </el-dialog>
          <!-- <el-upload action=""
                     accept=".jpg,.jpeg,.webp,.png,.JPG,.JPEG"
                     :show-file-list="false"
                     :auto-upload="false"
                     :on-change="getFile"
                     :file-list="pictureList">
            <el-button size="small"
                       type="primary">点击上传</el-button>
          </el-upload>
          <el-image v-if="diagramInfo.picture"
                    style="width: 100px; height: 100px"
                    :src="diagramInfo.picture"
                    :preview-src-list="[diagramInfo.picture]"
                    fit="fill"></el-image> -->
        </el-form-item>
        <el-form-item label="设施："
                      prop="room_type_facilities">
          <el-select multiple
                     collapse-tags
                     v-model="diagramInfo.room_type_facilities"
                     placeholder="请选择设施">
            <el-option v-for="item in deviceList"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="床位："
                      prop="room_type_bed">
          <el-select multiple
                     collapse-tags
                     v-model="diagramInfo.room_type_bed"
                     placeholder="请选择设施">
            <el-option v-for="item in bedList"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/room_type/add' || '/room_type/edit'"
                 type="primary"
                 @click="handleConfirm('diagramForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      imgUpUrl: fetch.uploadImgUrl,
      imgDownUrl: fetch.downImgUrl,
      authId: localStorage.getItem('token'),
      diagramInfo: {
        name: '',
        picture: '',
        room_type_facilities: [],
        room_type_bed: []
      },
      diagramRules: {
        name: [{ required: true, message: '请输入房型名称' }]
      },
      deviceList: [],
      bedList: [],
      // 图片处理
      pictureList: [],
      // 图片预览弹窗
      dialogVisible: false
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加房型' : '编辑房型'
    }
  },
  created() {
    this.getItemList('deviceList', 'room_type_facilities')
    this.getItemList('bedList', 'room_type_bed')
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRoomTypeInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.diagramInfo = data
            this.diagramInfo.room_type_facilities = data.room_type_facilities
              ? data.room_type_facilities.split(',')
              : []
            this.diagramInfo.room_type_bed = data.room_type_bed ? data.room_type_bed.split(',') : []
            this.pictureList.push({
              url: data.picture
            })
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取菜单类型
    getItemList(type, code) {
      fetch.getItemList({ type_code: code }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this[type] = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleSuccess(res) {
      this.diagramInfo.picture = res.result.file_url
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      this.diagramInfo.picture = file.url
      this.dialogVisible = true
    },
    getFile(file) {
      this.getBase64(file.raw).then((res) => {
        this.diagramInfo.picture = res
        this.pictureList = [{ name: file.name, url: res }]
      })
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.diagramInfo))
          datas.room_type_facilities = datas.room_type_facilities.join(',')
          datas.room_type_bed = datas.room_type_bed.join(',')
          if (this.data.type === 'add') {
            fetch.addRoomType({ ...datas }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editRoomType({ ...datas }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
